/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */


function ContentCategoriesRoleDefinitionsPanelComponent(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                                        $location: JS5Object, ContentEditService: JS5Object, uiGridConstants: JS5Object,
                                                        ModalService: JS5Object, UtilsService: JS5Object, $timeout: JS5Function) {
    this.videoRoleMapping = [];
    this.roleTypes = [
        {
            label: 'Any', value: 'ANY'
        },
        {
            label: 'Pop-On', value: 'POP_ON'
        },
        {
            label: 'Roll-up', value: 'ROLL_UP'
        }
    ];

    this.requiresMapping = false;
    this.columnDefinitions = [{
        field: 'name',
        displayName: 'Language',
        sort: {
            direction: 'asc',
        },
        cellTemplate: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/roleDefinitionsPanel/checkbox-cell-template.html',
    }];
    this.$onInit = () => {
        setupGrid();
    };
    this.$onChanges = () => {
        this.videoRoleAcceptTemplate = _.get(this, `videoRole.${this.acceptTemplateType}`);
        _.set(this, 'requiresMapping', !!_.size(_.get(this, 'videoRoleAcceptTemplate.languageRoleMap')));

        setupGrid();
    };

    const setupGrid = () => {
        this.columnDefinitions = [{
            field: 'name',
            displayName: 'Language',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }];

        _.forEach(_.get(this, 'roles'), (role) => {
            this.columnDefinitions.push({
                field: role.id,
                displayName: role.name,
                cellTemplate: 'components/visual/grid/checkbox-cell-template.html',
            })
        });

        this.gridOptions.columnDefs = this.columnDefinitions;
        this.gridOptions.data = _.get(this, 'editData.languages');
    };

    this.requiresMappingCheckboxToggled = () => {
        if (this.requiresMapping) {
            if (_.isNil(this.videoRoleAcceptTemplate)) {
                _.set(this, `videoRole.${this.acceptTemplateType}`, {
                    displayMode: 'ANY',
                    type: _.get(this, 'roles[0].type'),
                    languageRoleMap: _.get(this, `previousMappings`, [])
                });
                _.unset(this, 'previousMappings');
                this.videoRoleAcceptTemplate = _.get(this, `videoRole.${this.acceptTemplateType}`);
            }
        } else {
            this.previousMappings = _.cloneDeep(_.get(this, `videoRole.${this.acceptTemplateType}.languageRoleMap`));
            _.unset(this, `videoRole.${this.acceptTemplateType}`);
            this.videoRoleAcceptTemplate = _.get(this, `videoRole.${this.acceptTemplateType}`);
        }
        setupGrid();
    };

    this.shouldBeChecked = (row: JS5Object, col: JS5Object) => {
        let shouldBeChecked = false;
        let mapping = _.find(_.get(this, 'videoRoleAcceptTemplate.languageRoleMap'), (languageRoleMapItem: JS5Object) => {
            return languageRoleMapItem.language.id === row.entity.id && languageRoleMapItem.role.id === col.field;
        });
        if (!_.isNil(mapping)) {
            shouldBeChecked = true;
        }
        return shouldBeChecked;
    };

    this.onRowSelection = (row: JS5Object, col: JS5Object, event: JS5Object) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        let language = _.find(this.editData.languages, (language: JS5Object) => {
            return language.id === row.entity.id;
        });
        let role = _.find(this.roles, (role: JS5Object) => {
            return role.id === col.field;
        });
        setupMappings(role, language);
        setupGrid();
        this.editorForm.$setDirty();
    };

    const setupMappings = (role: JS5Object, language: JS5Object) => {
        let languageRoleMap = _.get(this, 'videoRoleAcceptTemplate.languageRoleMap');
        if (_.isNil(languageRoleMap)) {
            _.set(this, 'videoRoleAcceptTemplate.languageRoleMap', []);
            _.set(this, 'videoRoleAcceptTemplate.type', role.type);
            languageRoleMap = _.get(this, 'videoRoleAcceptTemplate.languageRoleMap');
        }
        let mapping = _.find(languageRoleMap, (languageRoleMapItem: JS5Object) => {
            return languageRoleMapItem.language.id === language.id && languageRoleMapItem.role.id === role.id;
        });
        if (_.isNil(mapping)) {
            addMapping(languageRoleMap, language, role);
        } else {
            _.remove(languageRoleMap, (languageRoleMapItem: JS5Object) => {
                return languageRoleMapItem.language.id === mapping.language.id && languageRoleMapItem.role.id === mapping.role.id;
            })
        }
    };

    const addMapping = (languageRoleMap: JS5Object, language: JS5Object, role: JS5Object) => {
        let existingMapping = _.find(ContentEditService.originalContentCategoryObject.contentCategoryObject.videoRoles, (videoRole: JS5Object) => {
            return videoRole.id === this.videoRole.id;
        });
        if (!_.isNil(existingMapping)) {
            let languageRoleMapItem = _.find(_.get(existingMapping, `${this.acceptTemplateType}.languageRoleMap`), (languageRoleMapItem: JS5Object) => {
                return languageRoleMapItem.language.id === language.id && languageRoleMapItem.role.id === role.id;
            });
            if (!_.isNil(languageRoleMapItem)) {
                languageRoleMap.push(languageRoleMapItem);
            } else {
                languageRoleMap.push({
                    role: role,
                    language: language
                });
            }
        } else {
            languageRoleMap.push({
                role: role,
                language: language
            });
        }
    };

    this.processGridFilter = (renderableRows: JS5Object) => {
        renderableRows.forEach((row: JS5Object) => {
            row.visible = _.includes(_.toLower(row.entity.name), _.toLower(this.searchText));
        });
        return renderableRows;
    };


    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: this.columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}


angular.module('prism-ui.content').component('contentCategoriesRoleDefinitionsPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/roleDefinitionsPanel/content-categories-role-definitions-panel-template.html',
    controller: ContentCategoriesRoleDefinitionsPanelComponent,
    bindings: {
        editData: '<',
        headingText: '<',
        videoRole: '<',
        roles: '<',
        acceptTemplateType: '<'
    }
});
